import { Component, EventEmitter, Input, Output, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { TreeviewI18n } from '../../models/treeview-i18n';
import { TreeviewItem } from '../../models/treeview-item';
import { TreeviewConfig } from '../../models/treeview-config';
import { TreeviewComponent } from '../treeview/treeview.component';
import { TreeviewHeaderTemplateContext } from '../../models/treeview-header-template-context';
import { TreeviewItemTemplateContext } from '../../models/treeview-item-template-context';
import { DropdownMenuDirective } from '../../directives/dropdown-menu.directive';

@Component({
  selector: 'ngx-dropdown-treeview',
  templateUrl: './dropdown-treeview.component.html',
  styleUrls: ['./dropdown-treeview.component.scss']
})
export class DropdownTreeviewComponent implements OnInit {
  @ViewChild(DropdownMenuDirective) dropdownMenu!: DropdownMenuDirective;
  @Input() buttonClass = 'btn-outline-secondary';
  @Input() headerTemplate!: TemplateRef<TreeviewHeaderTemplateContext>;
  @Input() itemTemplate!: TemplateRef<TreeviewItemTemplateContext>;
  @Input() items!: TreeviewItem[];
  @Input() config: TreeviewConfig;
  @Output() selectedChange = new EventEmitter<TreeviewItem>();
  @Output() filterChange = new EventEmitter<string>();
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent!: TreeviewComponent;
  @Input() value?: TreeviewItem;
  @Input() sizeDropdown: string = '';
  dropdownClass: string | string[] = '';

  getText() {
    return this.value?.text || '-Selecciona-';
  }

  constructor(
    public i18n: TreeviewI18n,
    private defaultConfig: TreeviewConfig
  ) {
    this.config = this.defaultConfig;
  }

  ngOnInit(): void {
    this.dropdownClass = this.sizeDropdown === 'xs' ? 'dropdown-menu-xs': '';
  }

  onSelectedChange(item: TreeviewItem): void {
    if (this.value && item.value.value !== this.value?.value.value) {
      this.selectedChange.emit(item);
      this.dropdownMenu.dropdown.close();
    } else if (!this.value) {
      this.selectedChange.emit(item);
      this.dropdownMenu.dropdown.close();
    }
  }

  onFilterChange(text: string): void {
    this.filterChange.emit(text);
  }
}
